export const emptyRange = { start: null, end: null };

/**
 * Pure verse-tap range update. This never starts read-aloud; callers must
 * only use the result to update selection state.
 */
export const nextVerseRange = (current, verse, neighbor) => {
  if (!Number.isFinite(verse)) {
    return { ...emptyRange };
  }

  if (!current?.start) {
    return { start: verse, end: verse, anchor: verse };
  }

  if (current.start === current.end && current.start === verse) {
    return { ...emptyRange, anchor: null };
  }

  if (verse < current.start || verse > current.end) {
    return {
      start: Math.min(current.start, verse),
      end: Math.max(current.end, verse),
    };
  }

  if (verse === current.start) {
    const next = neighbor?.(current.start, 1);
    if (!next || next > current.end) {
      return { ...emptyRange, anchor: null };
    }
    return { start: next, end: current.end, anchor: next };
  }

  if (verse === current.end) {
    const prev = neighbor?.(current.end, -1);
    if (!prev || prev < current.start) {
      return { ...emptyRange, anchor: null };
    }
    return { start: current.start, end: prev };
  }

  return { start: verse, end: verse, anchor: verse };
};
